import styled from 'styled-components';


export const Content = styled.div`
  display: flex;
  flex-direction: row;
  place-content: center;
  align-items: center;
  justify-content: space-between;
  width: 100%;
 
`;
